module.exports = __webpack_public_path__ + "img/monique.3f05e28f.jpg";